import React from 'react'
import { getLeagueSearch } from '../../actions/api/index'
import common from '../../lib/transform/parsers/common'
import classNames from 'classnames'
import AnchorLink from './AnchorLink'


/**
 * Component to display search results as list
 * @param  {object} search state with all results
 * @param  {object} compStyle is style for show/hide of component
 * @param  {string} q holds searched value
 * @param  {string} message to display if search fails / return no results
 * @return {component} component to show search results
 */
export const SearchResultsList = ({
  search,
  searchUrl,
  compStyle,
  message,
  q
})=>{
  let tempstyle2 = {
    zIndex: '1',
    position: 'relative'
  }
  const noResults = (
    <div className="global-search">
      <div className="search-results search_results--active" style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.22)' }}>
        <div className="search-results__wrapper" style={ { 'width': '100%', background: '#fff' } }>
          <ul style={compStyle} className="search_results__suggestions search_results__suggestions--cat">
            <li className="search_results__item">
              <div className="search_results__link detailed">
                <div className="search_results__details">
                  <span className="search_results__label">{ message }</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
  //dont render lists if no result / keyword
  let resultsHtml = []
  let viewAllmsg = 'View all results for ' + q
  if(q.length <= 0 || search.totalRecords === undefined) {
    return <span />
  }else if(search.totalRecords <= 0) {
    return noResults
  }else{
    let resultsObj = search.results || []
    compStyle = tempstyle2
    resultsObj.map((item)=>{
      resultsHtml.push(
        <li className="search_results__item" key={'srcl-'+item.id}>
          <AnchorLink to={item.href} isRouterLink={false} className="search_results__link detailed">
            <div className="search_results__img">
              <img data-src={item.img} className="lazyload"/>
            </div>
            <div className="search_results__details">
              <span className="search_results__label">{item.text}</span>
            </div>
          </AnchorLink>
        </li>
      )
    })
  }
  return(
    resultsHtml.length > 0 &&
    <div className="global-search">
      <div className="search_results search_results--active" style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.22)' }}>
        <div className="search-results__wrapper" style={ { 'width': '100%' } }>
          <ul style={compStyle} className="search_results__suggestions search_results__suggestions--cat">
            {resultsHtml}
          </ul>
        </div>
        <footer>
            <AnchorLink isRouterLink={false} to={searchUrl}>{viewAllmsg}</AnchorLink>
        </footer>
      </div>
    </div> || <span />
  )
}
/**
 * Search component to show typeahead results for leagues search
 */
export default class Search extends React.Component {
  constructor(props) {
    super(props)
    let defaultSearchProps = {
      q : '',
      results : 0,
      search : {
        totalRecords : undefined,
        results : []
      }
    }
    this.state = {
      ...defaultSearchProps,
      compStyle : { display: 'none !important' },
      searchUrl : '/',
      message : ''
    }
    this.defaultSearchProps = defaultSearchProps
    this._onSubmit = this._onSubmit.bind(this)
    this._searchLeague = this._searchLeague.bind(this)
    this._searchTimeout
  }
  //update state with search data
  _getLeagueSearchData(edition, params) {
    let additionalQuery = { q: this.state.q, results: this.state.results }
    let leagueSearchPromise = getLeagueSearch(edition, params, additionalQuery)
    if(leagueSearchPromise) {
      leagueSearchPromise.then((data)=>{
        if(data) {
          let res = common.leagues.searchLeagueResults(data) || {}
          if(res.results && res.totalRecords >= 0) {
            this.setState({
              search : {
                results: res.results,
                totalRecords : res.totalRecords
              },
              message: res.message,
              compStyle: { display: 'block !important' }
            })
          }else{
            this.setState({
              search : {
                results: [],
                totalRecords : res.totalRecords
              },
              message: ''
            })
          }
        }
      }).catch((error)=>{
        console.error(error)
      })
    }
  }
  //update state with latest keyword and call api
  _searchLeague(event) {
    let hasSearchVal = (event.target.value.length > 0) ? true : false
    //reset state if no keyword
    if(!hasSearchVal) {
      this.setState({ 
        search : {
          totalRecords : undefined,
          results : []
        }
      })
    }
    //set state to create search url
    this.setState({ q : event.target.value }, ()=>{
      this.state.searchUrl = this._createSearchUrl()
    })
    //search for keyword in api
    if(hasSearchVal) {
      //debounce and search api
      window.clearTimeout(this._searchTimeout)
      this._searchTimeout = setTimeout(()=>{
        let { edition, params } = this.props
        this._getLeagueSearchData(edition, params)
      },500)
    }
  }
  //create a search URL to redirect to search page on return key
  _createSearchUrl() {
    let url = ''
    let queryVal = this.state.q
    if((queryVal !== '') && (queryVal.length > 0)) {
      let urlProps = {
        domain : 'http://'+this.props.edition.domain,
        path : '/search/results',
        q: encodeURIComponent(queryVal)
      }
      let { domain, path, q } = urlProps
      const { params = {} } = this.props
      url = [ domain, path ].join('') + '?'
      if (params.sport == 'cricket') {
        url += 'filter=cricket&'
      }
      url += 'q=' + q
    }
    return url
  }
  //on submit redirect to search page
  _onSubmit(event) {
    event.preventDefault()
    if(this.state.searchUrl !== '' && this.state.searchUrl !== '/') {
      window.location.href = this.state.searchUrl
    }
  }
  componentDidMount() {
    document.addEventListener('click', (e)=>{
      var searchBoxId = (e.target && e.target.id) ? e.target.id : ''
      if(searchBoxId !== 's-box') {
        this.setState({ ...this.defaultSearchProps })
      }
    })
  }
  render() {
    if(!this.props.enabled) {
      return '</span>'
    }
    return (
        <section className={classNames('search-section','icon-font-before', 'icon-search-solid-before')}>
          <form onSubmit={this._onSubmit}>
            <input type="text" id="s-box" className="search-box" value={this.state.q} placeholder="Search for England tour of Australia etc." autoComplete="off" onChange={this._searchLeague} />
          </form>
          <SearchResultsList key="ll" searchUrl={this.state.searchUrl} compStyle={this.state.compStyle} search={this.state.search} q={this.state.q} message={this.state.message} />
        </section>
    )
  }
}



// WEBPACK FOOTER //
// ../app/components/common/Search.jsx